import { createMuiStyles } from '../../../utils/mui';

export const accountMenuStyles = createMuiStyles({
  avatarBtn: {
    p: 0,
  },
  accountMenuItem: {
    fontSize: '.875rem',
    fontWeight: 'Medium',
  },
  profileMenu: {
    minWidth: '15rem',
  },
  profileMenuItem: {
    py: 1.25,
  },
  profileMenuIcon: {
    minWidth: '2.5rem!important',
  },
  myAccountIcon: {
    fontSize: '0.875rem!important',
  },
  tabletSignOutBtnWrapper: {
    borderTop: 1,
    borderColor: 'grey.200',
    pt: 2,
    mt: 2,
    ml: -2.5,
  },
  tabletSignOutBtn: {
    py: 2,
    px: 2.5,
    color: 'grey.800',
    display: 'flex',
    width: 1,
    justifyContent: 'flex-start',
    '&:hover, &:focus': {
      '&:not(.active)': {
        bgcolor: 'primary.light',
      },
    },
  },
});
